import React, {useState} from 'react'
import {Button, Form, Input, Modal} from "antd";
import {updateProduction, getProductionLineById} from "../../services/serviceProductionLine";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";

const formLayout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16}
}

const ProductionLineEdit = ({production, updater}) => {
    const [form] = Form.useForm()
    const [editModal, setEditModal] = useState(false)
    const [loadings, setLoadings] = useState([])


    const handleEditClick = () => {
        getProductionLineById(production.id)
            .then(({data}) => {
                form.setFieldsValue({
                    productionName: data.name,
                    productionCode: data.code
                })
            })
        setEditModal(!editModal)
    }

    const handleSubmit = (list) => {
        enterLoadingState(setLoadings)
        let request = {
            name: list.productionName,
            code: list.productionCode,
            id: production.id
        }
        updateProduction(request)
            .then(() => {
                exitLoadingState(setLoadings)
                setEditModal(!editModal)
                updater()
            })
            .catch(() => exitLoadingState(setLoadings))
    }

    return(
        <React.Fragment>
            <Button  type={'link'} onClick={()=>handleEditClick()}>Güncelle</Button>

            <Modal
                open={editModal}
                closable={false}
                title={`Üretim Hattı Güncelle`}
                footer={[
                    <Button type={'primary'} key={'SubmitButton'} loading={loadings[0]} onClick={()=> form.submit() }>Kaydet</Button>,
                    <Button onClick={() => setEditModal(!editModal)} key={'CloseButton'} >Kapat</Button>
                ]}
            >
                <Form
                    form={form}
                    {...formLayout}
                    onFinish={() => handleSubmit(form.getFieldsValue())}
                >
                    <Form.Item

                        label={'Üretim Hattı Adı'}
                        name={'productionName'}
                        rules={[
                            {required:true, message: 'Üretim Hattı Adı Boş Bırakılamaz'},
                            {min: 5, max: 300, message: 'Üretim Hattı Adı En Az 5 En Fazla 300 Karakter Olabilir'}
                        ]}
                    >
                        <Input  />

                    </Form.Item>
                    <Form.Item
                        name={'productionCode'}
                        label={'Üretim Hattı Kodu'}
                        rules={[
                            {required: true, message: 'Üretim Hattı Kodu Boş Bırakılamaz'},
                            {pattern: /^\S*$/gm, message: 'Üretim Hattı Kodu Alanı Boşluk İçeremez'},
                            {min: 3, max: 20, message: 'Üretim Hattı Kodu En az 3 En Fazla 20 Karakter Olabilir'}
                        ]}
                    >
                        <Input  />
                    </Form.Item>
                </Form>
            </Modal>

        </React.Fragment>
    )
}
export default ProductionLineEdit